<template>
  <div class="form-row row keyword-tags-list" style="margin-left:0px;">
    <div class="dropup" v-if="keyWordToTagList && keyWordToTagList.length > 0">
      <div
        class="bulk_action dropdown-toggle"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
		    style="z-index: 1;"
      >
        <span class="text">Bulk Actions</span>
      </div>
      <div
        class="dropdown-menu remove-style"
        aria-labelledby="dropdownMenuButton"
      >
      <a
          class="dropdown-item"
          style="cursor:pointer"
          :disabled="keyWordToTagList.length < 1"
          @click="
            selectedBulkAction = 'Add Bid';
            selectAction();
          "
          >{{'Add Min/Max Bid'}}</a
        >
        <a
          class="dropdown-item"
          style="cursor:pointer"
          href="javascript:void(0)"
          v-if="selectedTag && selectedTag.id && selectedTag.id != 'all'"
          :disabled="keywordList.length < 1"
          @click="
              selectedBulkAction = 'Delete \''+selectedTag.title+'\' from all';
              selectAction();
            "
          >Delete '{{ selectedTag.title }}' from all</a
        >
        <a
          class="dropdown-item"
          style="cursor:pointer"
          href="javascript:void(0)"
          v-if="selectedTag && selectedTag.id && selectedTag.id != 'all'"
          :disabled="keywordList.length < 1"
          @click="
            selectedBulkAction =
              'Delete \''+selectedTag.title+'\' from selected';
            selectAction();
          "
          >Delete '{{ selectedTag.title }}' from selected
        </a>
      </div>
    </div>
    <TagKeyword @closeModal="closeModal" />
    <BulkMinMaxBidPopUp :maxBidLimit='maxBidLimit' :minBidLimit="minBidLimit" :keywordList="keywordList" @closeMinMaxBidModal="closeMinMaxBidModal"/>
    <DeleteTagKeywordPopUp
      :tag="selectedTag"
      @closeDelTag="closeDelTag"
      :deleteAll="deleteAll"
      :amsCampaignId="amsCampaignId"
    />
  </div>
</template>

<script>
import BulkMinMaxBidPopUp from "@/components/keyword/BulkMinMaxBidPopUp.vue";
import TagKeyword from "@/components/keyword/TagKeyword.vue";
import Multiselect from "vue-multiselect";
import DeleteTagKeywordPopUp from "@/components/keyword/DeleteTagKeywordPopUp.vue";

export default {
  name: "KeywordActions",
  data() {
    return {
      selectedBulkAction: "Action",
      selectedTag: null,
      tagsList: [],
      deleteAll: false,
      amsCampaignId: "",
      minMaxBid:'',
    };
  },
  props: {
    keywordList: {
      type: Array,
    },
    minBidLimit:{
      type:String
    },
    maxBidLimit:{
      type:String
    }
  },
  components: {
    TagKeyword,
    Multiselect,
    DeleteTagKeywordPopUp,
    BulkMinMaxBidPopUp
  },
  watch: {
    selectedTag() {
      this.$emit("updateSelTag", this.selectedTag);
    },
  },
  computed: {
    keyWordToTagList: {
      get() {
        return this.$store.state.campaign.keyWordToTagList;
      },
      set(val) {
        this.$store.state.campaign.keyWordToTagList = val;
      },
    },
    actionSelectionControl: {
      set(val) {
        this.$store.state.campaign.actionSelectionControl = val;
      },
      get() {
        return this.$store.state.campaign.actionSelectionControl;
      },
    },
  },
  mounted() {
    this.selectedTag = [];
    this.amsCampaignId = this.$route.params.amsCampaignId;
    // this.getData();
  },
  methods: {
    getData() {
      let vm = this;
      this.$store
        .dispatch("campaign/getTagsForKeyword", {
          type: this.$route.params.sponsoredType == "sd" ? "asin" : "keyword",
        })
        .then((data) => {
          if (data && data.length && data[0].id != "all")
            data.unshift({ id: "all", title: "All Tags" });
          vm.tagsList = data;
        });
    },
    selectAction() {
      if (this.selectedBulkAction == "Add tags") {
        $("#taggableKeyword").modal("show");
      } else if (this.selectedBulkAction == "Delete tag from Keyword") {
        this.deleteAll = false;
        $("#deleteTag").modal("show");
      }
      else if(this.selectedBulkAction == "Add Bid"){
        $("#minMaxBidBulk").modal("show");
      }

      // if (this.selectedTag && this.selectedTag.id != "all") {

      //   if (
      //     this.selectedBulkAction ==
      //     `Delete '${this.selectedTag.title}' from all`
      //   ) {
      //     this.deleteAllTag();
      //   }
      //   if (
      //     this.selectedBulkAction ==
      //     `Delete '${this.selectedTag.title}' from selected`
      //   ) {
      //     this.deleteAll = false;
      //     $("#deleteTag").modal("show");
      //   }
      // }
    },
    closeDelTag(data) {
      this.selectedBulkAction = "Action";
      this.keyWordToTagList = [];
      this.actionSelectionControl = false;
      this.deleteAll = false;
      $("#deleteTag").modal("hide");
      if (data) {
        this.$emit("getKeywordForTagsList", data.id);
      }
    },
    closeMinMaxBidModal(type){
      this.selectedBulkAction = "Action";
      this.keyWordToTagList = [];
      debugger
      if (type && type == "save") {
        this.$emit("fetchKeywordList");
      }
      $("#minMaxBidBulk").modal("hide");
    },
    closeModal(type, data) {
      this.selectedBulkAction = "Action";
      this.keyWordToTagList = [];
      if (type == "save") {
        if (data && data.length) {
          data[0].id = data[0].tag_id;
          this.tagsList.push(data[0]);
        }
        this.$emit("fetchKeywordList");
      }
      $("#taggableKeyword").modal("hide");
    },
    selectTag(data) {
      this.resetFooter();
      this.actionSelectionControl = false;
      if (data.id == "all") {
        this.selectedTag = "";
        this.$emit("fetchKeywordList", "all");
      } else {
        this.selectedTag = data;
        this.$emit("getKeywordForTagsList", data.id);
      }
    },
    resetFooter() {
      sessionStorage.setItem("keyword:keywordShowPerPage", 25);
      this.$store.state.keywordCurrentPageNumber = 1;
      this.$store.state.keywordShowPerPage = 25;
      this.$store.state.totalKeywordCount = 0;
      this.$store.state.campaign.keyWordToTagList = [];
      this.$store.state.campaign.actionSelectionControl = false;
    },
    resetFilter() {
      this.resetFooter();
      this.selectedTag = [];
      this.$emit("fetchKeywordList", "all");
    },
    deleteAllTag() {
      this.deleteAll = true;
      $("#deleteTag").modal("show");
    },
    showcamelCase(word) {
      let data = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return `${data}`;
    },
  },
};
</script>

<style lang="scss">
.keyword-tags-list {
  .multiselect__single {
    text-transform: none !important;
    overflow: hidden;
  }
  .multiselect__option span {
    text-transform: none !important;
  }
}
</style>
